import { AccessToken, IIdentity } from './';
import { WpEvent, WpEventHandler } from './../Common';
import { UserManager, User, UserManagerSettings } from 'oidc-client';
import AppSettingsInitializedEventArgs from '../Global/app-settings-initialized-event-args';
import { AppSettings } from '../Global/app-settings';
import GlobalService, { ILocalizationService, LocalizationSymbols } from '..';
import IContext from './i-context';
import IdentityChangedEventArgs from './identity-changed-event-args';

export default class UserIdentity implements IIdentity, IContext {
    private _user?: User | null;
    private _manager?: UserManager;
    private _managerSettings: any;
    private _identityChanged: WpEventHandler<IdentityChangedEventArgs>;

    IsInitialized: boolean = false;

    get AccessToken(): AccessToken {
        let accessToken = this._user?.access_token ?? '';
        let date = this._user != null ? new Date(this._user.expires_in) : new Date();

        return new AccessToken(accessToken, date);
    }
    get IsAuthentificated(): boolean {
        return this._user != null && this._user != undefined && !this._user.expired;
    }
    get Username(): string {
        return this._user?.profile?.preferred_username ?? "";
    }
    get UserId(): string {
        return this._user?.profile?.sub ?? "";
    }
    get Phone() {
        return this._user?.profile?.phone_number;
    }
    set Phone(val: string | undefined) {
        if (this._user != null && this._user.profile != null) {
            this._user.profile.phone_number = val;
        }
    }

    get IdentityChanged(): WpEvent<IdentityChangedEventArgs> {
        return this._identityChanged;
    }
    get CurrentIdentity(): IIdentity {
        return this;
    }

    constructor(managerSettings: any) {
        this._identityChanged = new WpEventHandler<IdentityChangedEventArgs>();
        this._managerSettings = managerSettings;
    }

    SignIn(): void {
        if (this._manager != null)
            this._manager.signinRedirect();
        else
            Error("Manager not initialzed");
    }

    SignOut(): void {
        if (this._manager != null)
            this._manager.signoutRedirect();
        else
            Error("Manager not initialzed");
    }

    ChangeIdentity(identity: IIdentity) {
        throw new Error("Method not implemented.");
    }

    async Refresh() {
        if (this._user != null && this._user.profile != null && this._manager != null) {
            console.log(this._user);
            this._user = await this._manager.signinSilent({ access_token: this.AccessToken });
            console.log(this._user);
        }
    }

    public async Initialize(appSettings: AppSettings, globalService: GlobalService) {
        this._manager = new UserManager(this._managerSettings);

        this._manager.events.addUserLoaded(this.userSigninEvent);
        this._manager.events.removeUserLoaded(this.userSignoutEvent);
        this._manager.events.addUserSignedOut(this.userSignoutEvent);
        this._manager.events.removeUserSignedOut(this.userSignoutEvent);

        this._user = await this._manager.getUser();

        if (this._user != null) {
            let args = new IdentityChangedEventArgs(this);
            this._identityChanged.Send(this, args);
        }
        this.IsInitialized = true;
    }

    protected userSigninEvent(user: User) {
        this._user = user;
        let args = new IdentityChangedEventArgs(this);
        this._identityChanged.Send(this, args);
    }
    protected userSignoutEvent() {
        this._user = null;
    }
}